import DashboardTile from 'app/frontend/base/components/DashboardTile'
import { useGuild } from 'app/frontend/base/config/context/guild'

const EntityLinksTile = ({
  className,
  uriLinkFragment,
}: {
  className?: string
  uriLinkFragment: string
}) => {
  const { guild, guildReference, teamReference } = useGuild()
  const guildInfo = guild || guildReference

  return (
    <DashboardTile
      className={className}
      innerClassName='h-8'
      title='links'
      dataPresent={true}
    >
      <div className='flex gap-2'>
        {teamReference?.spreadsheetPath ? (
          <a
            href={teamReference.spreadsheetPath}
            target='_blank'
            rel='noreferrer'
          >
            <img
              src='https://data.wowaudit.com/img/sheets-logo.png'
              className='w-6 min-w-6'
            />
          </a>
        ) : null}
        <a
          href={
            guildInfo?.blizzardUrl ||
            `https://worldofwarcraft.blizzard.com/en-gb/guild/${uriLinkFragment}`
          }
          target='_blank'
          rel='noreferrer'
        >
          <img
            src='https://data.wowaudit.com/img/wow-logo.png'
            className='w-6 min-w-6'
          />
        </a>
        <a
          href={
            guildInfo?.wclUrl ||
            `https://www.warcraftlogs.com/guild/${uriLinkFragment}`
          }
          target='_blank'
          rel='noreferrer'
        >
          <img
            src='https://data.wowaudit.com/img/wcl-logo.png'
            className='w-6 min-w-6'
          />
        </a>
        <a
          href={
            guildInfo?.raiderioUrl ||
            `https://raider.io/guilds/${uriLinkFragment}`
          }
          target='_blank'
          rel='noreferrer'
        >
          <img
            src='https://data.wowaudit.com/img/raiderio-logo.png'
            className='w-6 min-w-6 border rounded-full'
          />
        </a>
      </div>
    </DashboardTile>
  )
}

export default EntityLinksTile
